define('views/DisclaimerView',[
    'backbone',
    'text!templates/disclaimer.html',
    'lodash'
], function (Backbone, disclaimerTmpl, _) {

    'use strict';

    return Backbone.View.extend({

        tagName: 'article',

        template: _.template(disclaimerTmpl),

        render: function () {
            this.$el.html(this.template());
        }

    });

});
